import { Controller } from "@hotwired/stimulus"

// Fills a hidden field with the browser's IANA zone at signup.
//
// The daily rituals turn over at the keeper's own midnight rather than the
// server's, so the zone is game state and not a display preference. Asking for it
// in a select would be a dropdown of four hundred options on the one screen that
// has to feel like no work at all; the browser already knows.
export default class extends Controller {
  connect() {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (zone) this.element.value = zone
  }
}
